export enum FORMS {
    CONTACT_FORM = 'contact-form',
    PROSPECT_REGISTRATION_FORM = 'propspect-registration-form',
    APPOINTMENT_FINDER_CONTACT_REQUEST = 'appointment-finder.contact-request.form',
    APPOINTMENT_FINDER_BOOKING_CONFIRMATION_POPUP = 'appointment-finder.booking-confirmation-popup.form',
    SECURE_INBOX_COMPOSE_MESSAGE = 'secure-inbox.compose-message.form',
    SECURE_DOCUMENT_STORE_DOCUMENT_INFORMATION = 'secure-document-store.document-information.form',
}
